import {
  birthDateValidationSchema,
  emailValidationSchema,
  firstNameValidationSchema,
  lastNameValidationSchema,
  phoneNumberValidationSchema,
} from '@/schemas/ValidationSchema.ts';
import { z } from 'zod';

export const waitlistParticipantSchema = z.object({
  firstName: firstNameValidationSchema,
  lastName: lastNameValidationSchema,
  birthDate: birthDateValidationSchema,
});

export const waitlistSchema = z.object({
  fillerType: z.enum(['participant', 'client']),
  firstName: firstNameValidationSchema,
  lastName: lastNameValidationSchema,
  birthDate: birthDateValidationSchema,
  email: emailValidationSchema,
  phoneNumber: phoneNumberValidationSchema,
  participants: z
    .array(waitlistParticipantSchema)
    .min(1, 'Wymagany jest co najmniej jeden uczestnik'),
  note: z
    .string()
    .max(1000, 'Notatka może mieć maksymalnie 1000 znaków')
    .optional(),
});

export type WaitlistParticipantForm = z.infer<typeof waitlistParticipantSchema>;
export type WaitlistForm = z.infer<typeof waitlistSchema>;
